module.exports = __webpack_public_path__ + "img/rent.92120fbe.svg";